module.exports = __webpack_public_path__ + "static/media/testimony2.d9aaed17.png";